import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";

import { useSession } from "@/lib/auth-client";

/**
 * Requires authentication but does NOT require tenant membership.
 *
 * Use this for routes that authenticated users can access regardless
 * of their tenant status, such as:
 * - Onboarding wizard
 * - Pending approval screen
 * - Account settings (if tenant-independent)
 */
export function AuthenticatedRoute() {
  const { data: session, isPending } = useSession();
  const location = useLocation();

  if (isPending) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
